(function () {
	'use strict';

	var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);

	$('[data-tabs]').each(function () {
		var nav = $(this);
		var links = nav.find('a');
		var panel = $(links.eq(0).attr('href')).parent();

		if (panel.length) {
			var panels = $(panel[0].children);

			// Opens tab ID
			var openTab = function (id) {
				var activeLink = links.filter('[href="#' + id + '"]');
				var activePanel = panels.filter('#' + id);

				links.removeClass('active');
				activeLink.addClass('active');

				if (activePanel.length) {
					panels.removeClass('active');
					activePanel.addClass('active');

					// Scroll version
					// var activeOffset = activePanel.offset();
					// var panelOffset = panel.offset();
					// var scrollLeft = (activeOffset.left - panelOffset.left) + panel.prop('scrollLeft');
					// panel.animate({scrollLeft: scrollLeft}, 250);
				}
			};

			// Open tabs on link click
			links.on('click', function (e) {
				e.preventDefault();
				openTab($(this).attr('href').substr(1));
			});

			// Open first link on load
			openTab(links.eq(0).attr('href').substr(1));
		}
	});
})();
